// isCommentsEnabled is true when the organization has the comments feature toggle enabled
export function isCommentsEnabled(organization) {
    return !!organization?.Settings?.Comments?.Enabled
}

// isPostTemplatesEnabled is true when the organization has the post templates feature toggle enabled
export function isPostTemplatesEnabled(organization) {
    return !!organization?.Settings?.PostTemplates?.Enabled
}
